module.exports = __webpack_public_path__ + "static/icon-c30d0422898dc845de40dda10c89d7bb.png";